function deeplink(destination, additionalInfo, callback, browserName, abi) {

	function isString(input) {
		return (typeof input === 'string' || input instanceof String);
	}

	function isJson(inputJson) {
		try {
	        JSON.parse(inputJson);
	    } catch (error) {
	        return false;
	    }
	    return true;
	}

	function isFunction(inputCallback) {
		return typeof inputCallback === 'function';
	}

	function isInvalidInput(destination, additionalInfo, callback, browserName, abi) {
		return !isString(destination.applicationScheme) || !isString(destination.stateName) || 
				(destination.urlSSO && !isString(destination.urlSSO)) || !isJson(additionalInfo) || 
				!isFunction(callback) || !isString(browserName) || !isString(abi);
	}

	function openApp(destination, additionalInfo, browserName, abi) {
		var additionalInfoEncoded = encodeURIComponent(isString(additionalInfo) ? additionalInfo : JSON.stringify(additionalInfo));
		console.log(additionalInfoEncoded);
		var urlWithParameters = destination.applicationScheme + "?stateName=" + 
				encodeURIComponent(destination.stateName) + (destination.action ? "&action=" + encodeURIComponent(destination.action) : "" ) +  (destination.urlSSO ? "&urlSSO=" + encodeURIComponent(destination.urlSSO) : "" ) + 
				"&additionalInfo=" + additionalInfoEncoded + "&nomeBrowser=" + browserName + "&abi=" + abi +
				(destination.redirectURL ? "&redirect_url=" + encodeURIComponent(destination.redirectURL) : "" );
		
		console.log("Trying to open app");
		console.log(urlWithParameters);

		window.location.replace(urlWithParameters);
		setTimeout(callback,2000);
	}

	function deeplinkUnsafe(destination, additionalInfo, browserName, abi) {
		if ( !destination || !destination.applicationScheme || !destination.stateName || !additionalInfo || !callback || !browserName || !abi) {
			console.log("Invalid request, missing parameters");
			return 1;
		}

		if (isInvalidInput(destination, additionalInfo, callback, browserName, abi)) {	
			console.log("Invalid parameters");
			return 2;
		}

		openApp(destination, additionalInfo, browserName, abi)

		return 0;
	}

	try {
		console.log("Launching app")
		return deeplinkUnsafe(destination, additionalInfo, browserName, abi)
	} catch (error) {
		return 3;
	}
}
